import { createContext, PropsWithChildren, useContext } from "react";

import { ICnasClient, CnasClient } from "@atlassiansox/asc-cnas";

const CnasClientContext = createContext<ICnasClient>(new CnasClient());

export function useCnasClient(): ICnasClient {
    return useContext(CnasClientContext);
}

export type CnasClientProviderProps = PropsWithChildren<{
    readonly client: ICnasClient;
}>;

export const CnasClientProvider = ({
    client,
    children
}: CnasClientProviderProps) => {
    return (
        <CnasClientContext.Provider value={client}>
            {children}
        </CnasClientContext.Provider>
    );
};
